export const contactsData = {
    email: 'rakeshganeshula@gmail.com',
    phone: '+919398347981',
    address: 'Vinjaram, Kukunoor(Mandal), WestGodavari(district), Andhra Pradesh - 534444 ',
    sheetAPI: 'https://sheetdb.io/api/v1/464e559xnfq9p'
}